(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-nh-article]').forEach(article => {
      if (article.dataset.nhReady) return;
      article.dataset.nhReady = 'true';
      const body = article.querySelector('[data-nh-body]');
      const toc = article.querySelector('[data-nh-toc]');
      if (!body || !toc) return;
      const list = toc.querySelector('ol');
      const headings = Array.from(article.querySelectorAll('.nh-takeaways h2, [data-nh-body] h2:not([data-nh-no-toc])'));
      headings.forEach((heading, index) => {
        if (!heading.id || /^nh-section-\d+$/.test(heading.id)) {
          const baseId = heading.textContent.toLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'abschnitt';
          let id = baseId;
          let suffix = 2;
          while (document.getElementById(id) && document.getElementById(id) !== heading) id = `${baseId}-${suffix++}`;
          heading.id = id;
        }
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        item.append(link);
        list.append(item);
      });
      toc.hidden = !list.children.length;
      const readingContent = article.querySelector('[data-nh-reading-content]') || body;
      const bar = article.querySelector('[data-nh-reading-bar]');
      if (!bar || !headings.length) return;
      const menu = bar.querySelector('[data-nh-reading-menu]');
      const menuList = bar.querySelector('[data-nh-reading-links]');
      Array.from(list.children).forEach(item => menuList.append(item.cloneNode(true)));
      const links = [...list.querySelectorAll('a'), ...menuList.querySelectorAll('a')];
      const current = bar.querySelector('[data-nh-current-section]');
      const percent = bar.querySelector('[data-nh-reading-percent]');
      const progress = bar.querySelector('[data-nh-progress]');
      const fill = bar.querySelector('[data-nh-progress-fill]');
      const header = document.querySelector('.section-header');
      const controller = new AbortController();
      let pending = false;
      let observer;
      const update = () => {
        pending = false;
        if (!article.isConnected) {
          controller.abort();
          observer?.disconnect();
          return;
        }
        const headerRect = header?.getBoundingClientRect();
        const offset = headerRect ? Math.max(0, Math.min(headerRect.bottom, headerRect.height)) : 0;
        article.style.setProperty('--nh-header-offset', `${offset}px`);
        const rect = readingContent.getBoundingClientRect();
        const height = 53;
        const available = Math.max(1, window.innerHeight - offset - height);
        const distance = Math.max(1, rect.height - available);
        const value = Math.round(Math.min(1, Math.max(0, (offset + height - rect.top) / distance)) * 100);
        const visible = rect.top <= offset + height && rect.bottom > offset + height;
        bar.hidden = !visible;
        if (!visible) menu.open = false;
        let active = 0;
        headings.forEach((heading, index) => {
          if (heading.getBoundingClientRect().top <= offset + height + 40) active = index;
        });
        current.textContent = `${active + 1}. ${headings[active].textContent}`;
        percent.textContent = `${value} %`;
        progress.setAttribute('aria-valuenow', String(value));
        fill.style.transform = `scaleX(${value / 100})`;
        links.forEach(link => {
          if (link.hash === `#${headings[active].id}`) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      };
      const schedule = () => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(update);
      };
      links.forEach(link => link.addEventListener('click', () => { menu.open = false; schedule(); }, { signal: controller.signal }));
      document.addEventListener('click', event => {
        if (!menu.contains(event.target)) menu.open = false;
      }, { signal: controller.signal });
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && menu.open) { menu.open = false; menu.querySelector('summary').focus(); }
      }, { signal: controller.signal });
      window.addEventListener('scroll', schedule, { passive: true, signal: controller.signal });
      window.addEventListener('resize', schedule, { passive: true, signal: controller.signal });
      observer = new ResizeObserver(schedule);
      observer.observe(readingContent);
      if (header) observer.observe(header);
      update();
    });
    root.querySelectorAll('[data-nh-blog]').forEach(blog => {
      if (blog.dataset.nhReady) return;
      blog.dataset.nhReady = 'true';
      const buttons = Array.from(blog.querySelectorAll('[data-nh-filter]'));
      const cards = Array.from(blog.querySelectorAll('[data-nh-topics]'));
      const result = blog.querySelector('[data-nh-result]');
      buttons.forEach(button => button.addEventListener('click', () => {
        const topic = button.dataset.nhFilter;
        let count = 0;
        cards.forEach(card => {
          const visible = topic === 'alle' || card.dataset.nhTopics.split(/\s+/).includes(topic);
          card.hidden = !visible;
          if (visible) count += 1;
        });
        buttons.forEach(other => {
          const active = other === button;
          other.classList.toggle('is-active', active);
          other.setAttribute('aria-pressed', String(active));
        });
        if (result) result.textContent = `${count} ${count === 1 ? result.dataset.nhSingular : result.dataset.nhPlural}`;
      }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target.parentElement || document));
})();
